import React from "react";
import { Link } from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button } from "react-bootstrap";
import Footer from "../layouts/Footer";
import HeaderMobile from "../layouts/HeaderMobile";
import Avatar from "../components/Avatar";

import img1 from "../assets/img/img1.jpg";
import img7 from "../assets/img/img7.jpg";
import img8 from "../assets/img/img8.jpg";
import img10 from "../assets/img/img10.jpg";
import img11 from "../assets/img/img11.jpg";
import img12 from "../assets/img/img12.jpg";
import img13 from "../assets/img/img13.jpg";
import img14 from "../assets/img/img14.jpg";
import img15 from "../assets/img/img15.jpg";
import img20 from "../assets/img/img20.jpg";
import img21 from "../assets/img/img21.jpg";
import img22 from "../assets/img/img22.jpg";
import img23 from "../assets/img/img23.jpg";
import img24 from "../assets/img/img24.jpg";
import img25 from "../assets/img/img25.jpg";
import img26 from "../assets/img/img26.jpg";
import { RecurringPaymentsTable } from "../components/tables/recurringPaymentTable";
import { Bar } from "react-chartjs-2";
import CostEstimatesTable from "../components/tables/costsEstimatesTable";

export default function CostsEstimates() {

    const ctxLabel = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const ctxData1 = [20, 60, 50, 45, 50, 60, 70, 40, 45, 35, 25, 30];
  const ctxData2 = [1000, 4000, 30, 40, 60, 55, 45, 35, 30, 20, 15, 20];
  const ctxColor1 = '#506fd9';
  const ctxColor2 = '#DBDFFD';

    const dataBar = {
        labels: ctxLabel,
        datasets: [{
          data: ctxData1,
          backgroundColor: ctxColor1,
          barPercentage: 0.5
        }, {
          data: ctxData2,
          backgroundColor: ctxColor2,
          barPercentage: 0.5
        }]
      };
    
      const optionBar = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            max: 80
          }
        }
      };
    
      

      
  return (
    <React.Fragment>
      <HeaderMobile />
      <div className="main p-4 p-lg-5">
        <Row className="g-5">
          <Col xl>
            <ol className="breadcrumb fs-sm mb-2">
              <li className="breadcrumb-item"><Link to="#">Pages</Link></li>
              <li className="breadcrumb-item"><Link to="#">Billing</Link></li>
              <li className="breadcrumb-item active" aria-current="page">Costs Estimates</li>
            </ol>
            <h2 className="main-title">Costs Estimates</h2>

            <Nav className="nav-line mb-4">
              {/* <Nav.Link href="" className="active">Top Events</Nav.Link> */}
              <Nav.Link href="/bills/invoices" >Invoice</Nav.Link>
              <Nav.Link href="/bills/claims">Claims</Nav.Link>
              <Nav.Link href="/bills/history    ">Payment History</Nav.Link>
              <Nav.Link href="" className="active">Costs Estimates</Nav.Link>
            </Nav>

            <Row className="g-3">
              <Card className="">
                <Card.Header>
                  Monthly Costs Statistics
                </Card.Header>
                    <Card.Body>
                      <Bar data={dataBar} options={optionBar} className="ht-300" />
                    </Card.Body>
                    <Card.Footer>
                      {/* <pre><code className="language-html">{`<Bar data={dataBar} options={optionBar} className="ht-300" />`}</code></pre> */}
                    </Card.Footer>
              <CostEstimatesTable/>
                  </Card>
           </Row>
          </Col>
          <Col xl="4" className="d-none d-xl-block">

            <hr className="my-3 opacity-0" />

            <h5 className="section-title mb-4">Recent Items</h5>
            <ul className="event-group">
             
             
              <li className="event-item">
                <div className="event-icon bg-danger"><i className="ri-wallet-3-line"></i></div>
                <div className="event-body">
                  <h6><Link to="">Wallet</Link></h6>
                  <p>-1000</p>
                 
                </div>
              </li>
            </ul>

            <hr className="my-4 opacity-0" />

            <h5 className="section-title">Upcoming Appointments</h5>
            {/* <p className="text-secondary fs-sm mb-4">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia.</p> */}
            <ul className="event-group mt-4">
              <li className="event-item">
                <div className="event-icon"><i className="ri-calendar-event-fill"></i></div>
                <div className="event-body">
                  <h6><Link to="" className=" ">37th Birthday Celebration</Link></h6>
                  <p>Tomorrow, April 21, 6:00pm</p>
                  <div className="mutual-badge">
                    <ul>
                      <li><Avatar img={img13} /></li>
                      <li><Avatar img={img14} /></li>
                    </ul>
                    <label>Lea and 4 others are going</label>
                  </div>
                </div>
              </li>
              <li className="event-item">
                <div className="event-icon bg-secondary"><i className="ri-calendar-event-fill"></i></div>
                <div className="event-body">
                  <h6><Link to="">Food Restobar Opening</Link></h6>
                  <p>Friday, April 27, 8:00am</p>
                  <div className="mutual-badge">
                    <ul>
                      <li><Avatar img={img13} /></li>
                      <li><Avatar img={img14} /></li>
                    </ul>
                    <label>Lea and 4 others are going</label>
                  </div>
                </div>
              </li>
              <li className="event-item">
                <div className="event-icon bg-primary"><i className="ri-calendar-event-fill"></i></div>
                <div className="event-body">
                  <h6><Link to="">Monster Trucks Event</Link></h6>
                  <p>Saturday, April 30, 9:00m</p>
                  <div className="mutual-badge">
                    <ul>
                      <li><Avatar img={img13} /></li>
                      <li><Avatar img={img14} /></li>
                    </ul>
                    <label>You and 8 others are going</label>
                  </div>
                </div>
              </li>
            </ul>
         

          </Col>
        </Row>

        <Footer />
      </div>
    </React.Fragment>
  );
}